const ROLE_LABELS = { pemilik: 'Pemilik', admin: 'Admin', penghuni: 'Penghuni' };

export const getRoleLabel = role => ROLE_LABELS[role] || 'Pengguna';
